import React from 'react';

class LoadingComponent extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="progress">
        <div className="indeterminate"></div>
      </div>
    );
  }
}

export default LoadingComponent;


// WEBPACK FOOTER //
// ./src/components/LoadingComponent.js